import produce from 'immer'
import { Reducer } from 'redux';

import { SET_SELECTED_DEALS, SET_SELECTED_DEAL_TYPE } from 'redux/actions/types'

interface DealwatchState {
  selectedDeals: string[];
  selectedDealType: string|null;
}

const emptyState: DealwatchState = {
  selectedDeals: [],
  selectedDealType: null
}

const dealwatch:Reducer<DealwatchState, any> = (state = {
  ...emptyState
}, action:any) => {
  switch (action.type) {
    case SET_SELECTED_DEALS:
      return produce(state, draft => {
        draft.selectedDeals = action.selectedDeals
      })
    case SET_SELECTED_DEAL_TYPE:
      return produce(state, draft => {
        draft.selectedDealType = action.dealType
      })
    default:
      return state
  }
}

export default dealwatch
